import * as Sentry from "@sentry/react"
import { BackendGeolocation } from "src/types"

const backendApiBaseUrl = "https://api.asanarebel.com/api/v1/"

export async function getGeolocation(): Promise<BackendGeolocation> {
  try {
    const response = await fetch(backendApiBaseUrl + "geolocation")

    if (!response.ok) {
      throw new Error(`Geolocation API responded with ${response.status}`)
    }

    return (await response.json()) as BackendGeolocation
  } catch (e) {
    Sentry.captureException(e)

    return {
      city: "",
      country: "",
      currency: "eur",
      zipcode: "",
    }
  }
}

export async function trackWithSherlock({
  params,
}: {
  params: Record<string, string>
}) {
  await fetch(backendApiBaseUrl + "sherlock/tracking_events.json", {
    body: JSON.stringify(params),
    headers: { "Content-Type": "application/json" },
    method: "POST",
  })
}
